import { i18nFilter } from "app/filters/i18nFilter";
import type { FC } from "react";
import styled from "styled-components";
import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, rgba } from "@similarweb/styles";
import { CenteredFlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { NoDataLandscape } from "pro-features/components/NoData/src/NoData";

const EmptyStateTitle = styled.div<{ isSmallWidget: boolean; fontColor?: string }>`
    font-size: 16px;
    color: ${({ isSmallWidget }) =>
        isSmallWidget ? rgba(colorsPalettes.carbon[500], 0.6) : colorsPalettes.carbon[500]};
`;

const EmptyStateSubTitle = styled.div`
    color: ${rgba(colorsPalettes.carbon[500], 0.6)};
    font-size: 12px;
    text-align: center;
`;

const EmptyStateContainer = styled(CenteredFlexColumn)`
    height: 100%;
    flex: 1;
    padding: 24px;
`;

const EmptyStateIcon = styled(SWReactIcons)<{ isSmallWidget?: boolean }>`
    svg {
        width: ${({ isSmallWidget }) => (isSmallWidget ? "100px" : "160px")};
        height: ${({ isSmallWidget }) => (isSmallWidget ? "40px" : "99px")};
    }
`;

const NoDataLandscapeWrapper = styled.div`
    margin-top: 70px;
`;

interface IEmptyStateProps {
    titleKey: string;
    subTitleKey?: string;
    isSmallWidget?: boolean;
}

export const EmptyState: FC<IEmptyStateProps> = (props: IEmptyStateProps) => {
    const { titleKey, subTitleKey, isSmallWidget = false } = props;
    const i18n = i18nFilter();
    return (
        <EmptyStateContainer>
            <EmptyStateIcon
                iconName="no-data-lab"
                isSmallWidget={isSmallWidget}
            />
            <EmptyStateTitle isSmallWidget={isSmallWidget}>{i18n(titleKey)}</EmptyStateTitle>
            {!isSmallWidget && <EmptyStateSubTitle>{i18n(subTitleKey)}</EmptyStateSubTitle>}
        </EmptyStateContainer>
    );
};

export const NoDataState = () => {
    return (
        <NoDataLandscapeWrapper>
            <NoDataLandscape
                title={"traffic.sources.creatives.gallery.no.data.title"}
                subtitle={"traffic.sources.creatives.gallery.no.data.sub.title"}
            />
        </NoDataLandscapeWrapper>
    );
};
